import { useEffect, useRef, useState } from 'react';
import ComingSoon from '../../../components/ComingSoon';
import { ListingDetails_ListingData_listing } from '../../../types/graph/ListingDetails_ListingData';
import { set } from 'date-fns';

// Component interface
interface IProps {
  listing: ListingDetails_ListingData_listing & {
    hasAnalytics: boolean;
    analyticsUrl: string;
  };
}

// Form data validation schema

const Analytics: React.FC<IProps> = ({ listing }) => {
  // const [url, setUrl] = useState<any>(true);

  // const iframe = useRef<HTMLIFrameElement>(null);

  // useEffect(() => {
  //   const init = async () => {
  //     const result = await fetch(listing.analyticsUrl);
  //     const data = (await result.text()).replace('<!DOCTYPE html>', '');
  //     console.log('testing', data);
  //     //setUrl(data);
  //     //setUrl(URL.createObjectURL(data as unknown as Blob));
  //     if (iframe.current) {
  //       iframe.current.srcdoc = data;
  //     }
  //   };

  //   if (listing.hasAnalytics) {
  //     init();
  //   }

  //   console.log(listing.hasAnalytics, listing.analyticsUrl);
  // }, []);

  return (
    <>
      {listing.hasAnalytics ? (
        <>
          <iframe
            plausible-embed="true"
            src={listing.analyticsUrl}
            scrolling="no"
            frameBorder="0"
            loading="lazy"
            style={{ width: '1px', minWidth: '100%', height: '1600px' }}
          ></iframe>

          <script async src="https://plausible.io/js/embed.host.js"></script>
        </>
      ) : (
        <div className="flex flex-col space-y-4">
          <div className="shadow rounded-lg bg-gray-50">
            {/* <Design
            listing={listing}
            setPostData={setPostdata}
            postData={postData}
            setProcessing={setProcessing}
          /> */}
          </div>
          <div className="shadow rounded-lg bg-white">
            {/* <Facebook
            account={data.account}
            listing={listing}
            postData={postData}
            processing={processing}
          /> */}
            <ComingSoon
              label={`On Demand`}
              title="Analytics"
              description={`View your listing website analytics!`}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Analytics;
